// Auto-generated by tools/i18n/extract-to-common.mjs. Do not edit by hand.
export default {
  page_title: 'Identity Provider Integrations',
  add_provider: 'Add Provider',
  provider_name: 'Provider Name',
  tenant_id: 'Tenant ID',
  status: 'Status',
  click_to_copy: 'Click to copy',
  providers: {
    entra_id: 'Entra ID'
  },
  enabled: 'Enabled',
  disabled: 'Disabled',
  actions: 'Actions',
  edit: 'Edit',
  delete: 'Delete',
  empty_state: 'No identity providers configured. Click "Add Provider" to get started.',
  modal: {
    add_title: 'Add Identity Provider',
    edit_title: 'Edit Identity Provider',
    provider_name_label: 'Provider Name',
    tenant_id_label: 'Tenant ID',
    tenant_id_placeholder: 'Enter Tenant ID',
    is_enabled_label: 'Enable Provider',
    test_connection: 'Test Connection',
    test_success: 'Connection verified successfully',
    test_failed: 'Connection verification failed',
    test_in_progress: 'Testing connection...',
    save: 'Save',
    cancel: 'Cancel',
    url_copied: 'Admin consent URL copied to clipboard',
    url_copy_failed: 'Failed to copy URL to clipboard',
    consent_url_label: 'Admin Consent URL',
    consent_url_hint:
      'Copy this URL and provide it to your Microsoft Entra administrator so they can open it and grant the required permissions to the application.',
    validation: {
      provider_name_required: 'Provider name is required',
      tenant_id_required: 'Tenant ID is required',
      test_required: 'You must test the connection before saving'
    }
  },
  verification: {
    can_authenticate: 'Can Authenticate',
    can_authenticate_hint: 'Verifies that the application can authenticate using the provided credentials',
    can_query_users: 'Can Query Users',
    can_query_users_hint: 'Verifies that the application has permission to query user information',
    success: 'Success',
    failed: 'Failed'
  },
  messages: {
    fetch_failed: 'Failed to fetch providers configuration',
    save_success: 'Provider configuration saved successfully',
    save_failed: 'Failed to save provider configuration',
    delete_success: 'Provider deleted successfully',
    delete_failed: 'Failed to delete provider',
    delete_confirm_title: 'Delete Provider',
    delete_confirm_message: 'Are you sure you want to delete this provider? This action cannot be undone.',
    toggle_success: 'Provider status updated successfully',
    toggle_failed: 'Failed to update provider status'
  }
};
